/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IBreadcrumbViewProps } from '@msdyn365-commerce-modules/breadcrumb/src/modules/breadcrumb/./breadcrumb';

const BreadCrumbView: React.FC<IBreadcrumbViewProps> = props => {
    const { root, links, backButton, BreadcrumbContainer, BreadcrumbList, BreadcrumbListItem, separator } = props;
    if (!root && !links && !backButton) {
        props.context.telemetry.error('BreadCrumb content is empty, module wont render');
        return null;
    }

    const getBreadcrumbNameAndUrl = () => {
        let breadCrumbName = '';
        let breadCrumbUrl = '';
        if (root) {
            // @ts-ignore
            const nameArray = root.props.text ? link.props.text.split('^') : link.props.children.split('^');
            breadCrumbName = nameArray[1];
            // @ts-ignore
            breadCrumbUrl = root.props.href;
        }

        return { breadCrumbName, breadCrumbUrl };
    };
    return (
        <Module {...BreadcrumbContainer}>
            <Node {...BreadcrumbList}>
                {root && (
                    <Node {...BreadcrumbListItem}>
                        <a
                            // data-exp-event-id=`Category.Breadcrumb 1.${breadCrumbText} curriculum.click`
                            className='ms-breadcrumb_link'
                            // @ts-ignore
                            href={getBreadcrumbNameAndUrl().breadCrumbUrl}
                            aria-label={getBreadcrumbNameAndUrl().breadCrumbName}
                            // data-no-click='true'
                        >
                            <span itemProp='name'>{getBreadcrumbNameAndUrl().breadCrumbName}</span>
                        </a>
                        {/* {root} */}
                        {links && separator}
                    </Node>
                )}
                {backButton && <Node {...BreadcrumbListItem}>{backButton}</Node>}
                {links &&
                    links.map((link, index) => {
                        // @ts-ignore
                        const nameArray = link.props.text ? link.props.text.split('^') : link.props.children.split('^');
                        const breadCrumbText = nameArray[1];
                        return (
                            <React.Fragment key={index}>
                                <Node
                                    {...BreadcrumbListItem}
                                    className={classnames(
                                        BreadcrumbListItem.className,
                                        index === links.length - 1 ? 'breadcrumb_item-current' : ''
                                    )}
                                >
                                    <a
                                        // data-exp-event-id=`Category.Breadcrumb 1.${breadCrumbText} curriculum.click`
                                        className='ms-breadcrumb_link'
                                        // @ts-ignore
                                        href={link.props.href || ''}
                                        aria-label={breadCrumbText}
                                        data-no-click={index === links.length - 1 ? 'true' : 'false'}
                                    >
                                        <span itemProp='name'>{breadCrumbText}</span>
                                    </a>
                                    {/* {link} */}
                                    {links[index + 1] && separator}
                                </Node>
                            </React.Fragment>
                        );
                    })}
            </Node>
        </Module>
    );
};

export default BreadCrumbView;
